module.exports = __webpack_public_path__ + "img/sf-korea-photo.4102f4e.png";